
import {tap, map} from 'rxjs/operators';
import { Injectable, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { IErrorInfo } from '../manager/contracts/error-info';
import { ModalFormStatus } from '../manager/contracts/modal-form-status';
import { ModalHandle } from '../manager/contracts/modal-handle';

@Injectable()
export class ModalFormHostService {

    constructor(private modalService: BsModalService) {
        this.onInit();
    }

    public modalHandles$ = new BehaviorSubject<ModalHandle[]>([]);
    get modalHandles(): ModalHandle[] { return this.modalHandles$.value; }
    set modalHandles(value: ModalHandle[]) { this.modalHandles$.next(value); }

    public current: ModalHandle = null;
    public current$ = new ReplaySubject<ModalHandle>(1);

    public onInit() {
        this.modalHandles$.pipe(
            map(refs => refs.slice(-1)[0]),
            tap(current => this.current$.next(current)),)
            .subscribe();

        this.current$.subscribe(current => this.current = current);
    }

    public show(content: string | TemplateRef<any>, options: any): BsModalRef {
        const modalRef = this.modalService.show(content, options);
        const handle = new ModalHandle(modalRef);

        this.modalHandles.push(handle);
        this.modalHandles = [
            ...this.modalHandles
        ];

        return modalRef;
    }

    public setForm(form: NgForm) {
        const current = this.modalHandles.slice(-1)[0];
        if (current) {
            current.form = form;
        }

        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    public destroyModalRef() {
        this.modalHandles.pop();
        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    public close() {
        const current = this.modalHandles.slice(-1)[0];
        current.status = ModalFormStatus.Finished;

        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    public error(error?: Partial<IErrorInfo>) {
        const current = this.modalHandles.slice(-1)[0];
        current.status = ModalFormStatus.Error;
        current.error = !!error ? error : { };

        this.modalHandles = [
            ...this.modalHandles
        ];
    }

}
